import { render, staticRenderFns } from "./BackupRestoreView.vue?vue&type=template&id=217fa4c3&scoped=true&"
import script from "./BackupRestoreView.vue?vue&type=script&lang=js&"
export * from "./BackupRestoreView.vue?vue&type=script&lang=js&"
import style0 from "./BackupRestoreView.vue?vue&type=style&index=0&id=217fa4c3&prod&lang=scss&"
import style1 from "./BackupRestoreView.vue?vue&type=style&index=1&id=217fa4c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217fa4c3",
  null
  
)

export default component.exports